import api from 'services/inventory/equipment'

export const handleSave = async (values: any) => {
  let res = await api.create(values)

  return res?.data?.success
}
